import mixpanel from 'mixpanel-browser'

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN?.trim() ?? ''
/** Invoice Mixpanel projects use EU data residency — events sent to the US host are dropped. */
const MIXPANEL_API_HOST =
  import.meta.env.VITE_MIXPANEL_API_HOST?.trim() ||
  'https://api-eu.mixpanel.com'
const DEBUG_STORAGE_KEY = 'invoice-onboarding-analytics-debug'

let initialized = false

export const isMixpanelEnabled = () => Boolean(MIXPANEL_TOKEN)

export const isOnboardingAnalyticsDebugEnabled = () => {
  if (import.meta.env.DEV) return true
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(DEBUG_STORAGE_KEY) === 'true'
}

export const initMixpanel = () => {
  if (initialized || !isMixpanelEnabled()) {
    if (!initialized && import.meta.env.DEV && !isMixpanelEnabled()) {
      console.warn(
        '[Mixpanel] VITE_MIXPANEL_TOKEN is missing; analytics events will not be sent.',
      )
    }
    return
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    api_host: MIXPANEL_API_HOST,
    persistence: 'localStorage',
  })
  initialized = true

  if (isOnboardingAnalyticsDebugEnabled()) {
    console.info('[Mixpanel] initialized', {
      tokenPresent: true,
      api_host: MIXPANEL_API_HOST,
    })
  }
}

export const trackMixpanel = (
  event: string,
  properties?: Record<string, unknown>,
) => {
  initMixpanel()

  if (!isMixpanelEnabled()) {
    if (isOnboardingAnalyticsDebugEnabled()) {
      console.info('[Mixpanel] skipped (no token)', event, properties)
    }
    return false
  }

  try {
    mixpanel.track(event, properties)
    if (isOnboardingAnalyticsDebugEnabled()) {
      console.info('[Mixpanel] track', event, properties)
    }
    return true
  } catch (error) {
    console.warn('[Mixpanel] track failed', event, error)
    return false
  }
}
